import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="webview-navigation"
export default class extends Controller {
  static targets = []

  connect() {
    this.boundHandleClick = this.handleClick.bind(this)
    this.element.addEventListener('click', this.boundHandleClick)
  }

  disconnect() {
    this.element.removeEventListener('click', this.boundHandleClick)
  }

  handleClick(event) {
    // Find the closest element with data-url attribute
    const clickedElement = event.target.closest('[data-url]')

    if (clickedElement) {
      event.preventDefault()
      const url = clickedElement.dataset.url

      // Basic URL validation to prevent javascript: or data: URLs
      if (url && this.isValidUrl(url)) {
        window.location.href = url
      }
    }
  }

  isValidUrl(url) {
    // Only allow relative URLs or HTTP/HTTPS URLs
    // Prevent javascript:, data:, vbscript:, etc.
    return url.startsWith('/') || url.startsWith('http://') || url.startsWith('https://')
  }
}
